import type { DisplayPlayerProp } from "@/components/optimizer/utils-v2/types";
import { resultRows } from "@/lib/odds-screen/live/derive";
import type { Catalog, FamilySummary } from "@/lib/odds-screen/live/types";

const TEAM_SLOT = "team_total";

function teamEntity(name: string): string {
  return name.trim().toLowerCase().split(/\s+/).join("_");
}

function entityOf(family: FamilySummary, row: DisplayPlayerProp): string | null {
  if (family.kind === "props") return row.entity_key || null;
  if (family.layout === "results") return (resultRows(family) === "side" ? row.outcome_key : row.entity_key) || null;
  if (!family.markets.some((market) => market.id === TEAM_SLOT)) return "";
  return row.team && row.team_short ? teamEntity(row.team) : null;
}

export function oddsScreenHrefForLiveRow(catalog: Catalog | null, row: DisplayPlayerProp): string | null {
  const league = row.league?.toLowerCase();
  const key = row.stat_type;
  if (catalog === null || !league || !key || !row.event_id) return null;
  const family = catalog.leagues.get(league)?.families.find((entry) => entry.markets.some((market) => market.keys.includes(key)));
  if (family === undefined) return null;
  const params = new URLSearchParams({ family: family.id });
  const entity = entityOf(family, row);
  if (entity !== null) {
    params.set("game", row.event_id);
    if (entity !== "") params.set("entity", entity);
  }
  return `/odds-screen/${league}?${params.toString()}`;
}
